import React from 'react';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Shape10 from "../../images/shape10.png";

import './style.scss';

const WhoWeAre = ({className = ''}) => {
    return(
        <Grid className={`AboutOne2PayWrapper ${className}`}>
            <Grid
                container
                alignItems="center"
                spacing={4}
                className="container xs-column-reverse">
                <Grid item xs={12} md={6}>
                    <Grid className="textContent">
                        <strong>About Us</strong>
                        <h2>Do it yourself with our help. Let us make your life a little bit easier. </h2>
                        <h5>OneTwoPay, your simple pay stub solution.</h5>
                        <p>We’re passionate about giving you the tools you need to build pay stubs without any extra time or stress. Helping you better serve your employees, our generation platform utilizes official CRA calculations and prompts you to add all the required information you need for your professional Canadian pay stubs.</p>
                        <Button component="a" className="cBtn">Create a Pay Stub</Button>
                    </Grid>
                </Grid>
                <Grid container justify={'center'} item xs={12} md={6}>
                    <Grid className="textThumb rthumb">
                        <img  src={Shape10} alt="Working Made Easy"/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default WhoWeAre;